import React, { useRef, useState } from "react";

import "./style.css";
import Title from "./Title";
import Toolbar from "./Toolbar";
import Panel from "./Panel";
import Info from "./Panelview/Info/Info";
import Data from "./Panelview/Data";
import Config from "./Panelview/Config/";
import ListPathway from "./Panelview/List";
import Graph from "./Graph";
import { useParams } from "react-router-dom";

const Viewer = () => {
  let { sessionId } = useParams();

  const [panel, setPanel] = useState("Info"),
    InnerPanel = panels[panel],
    [selectedElements, selectElements] = useState([]),
    [layoutFns, setLayoutFns] = useState(null),
    [term, setTerm] = useState(""),
    panelRef = useRef(),
    fullscreenRef = useRef();

  function activatePanel(panel) {
    panel !== "Fullscreen" ? changePanel(panel) : fullscreen();
  }

  function changePanel(panel) {
    if (fullscreenRef.current.classList.contains("fullscreen")) {
      fullscreenRef.current.classList.remove("fullscreen");
      layoutFns.resize();
      layoutFns.resetZoom();
    }
    panelRef.current.classList.add("open");
    setPanel(panel);
  }

  function close() {
    panelRef.current.classList.remove("open");
  }

  function fullscreen() {
    fullscreenRef.current.classList.toggle("fullscreen");
    layoutFns.resize();
    layoutFns.resetZoom();
  }

  return (
    <div className="viewer" ref={fullscreenRef}>
      <Title sessionId={sessionId} />
      <Graph
        key={sessionId}
        sessionId={sessionId}
        setLayoutFns={setLayoutFns}
        selectElements={selectElements}
        layoutFns={layoutFns}
      />
      <Toolbar onSelection={activatePanel} activePanel={panel} />
      <Panel ref={panelRef} onClose={close}>
        <InnerPanel
          sessionId={sessionId}
          layoutFns={layoutFns}
          term={term}
          setTerm={setTerm}
          selected={selectedElements}
        />
      </Panel>
    </div>
  );
};

const panels = {
  ListPathway: ListPathway,
  Info: Info,
  Config: Config,
  Data: Data,
};

export default Viewer;
